<template>
  <footer class="bg-gray-800 mt-20 text-white py-8 pb-[90px]">
    <div class="container mx-auto px-4">
      <div class="flex flex-col md:flex-row items-center justify-between mb-6">
        <!-- <div class="flex items-center mb-4 md:mb-0 ml-[-3px]">
          <img width="57" src="@/assets/logo.jpg" alt="" />
          <span
            class="text-2xl font-bold text-white text-slate-900 dark:text-white uppercase"
            >Dongguan Huadai Silicone Co., Ltd.</span
          >
        </div> -->
      </div>

      <div class="grid grid-cols-1 md:grid-cols-3 gap-8">
        <div class="border-r border-gray-700 pr-4">
          <h3 class="text-xl font-bold mb-4 text-white">CONTACTS</h3>
          <ul class="text-sm space-y-2 text-gray-400">
            <li><i class="fa fa-phone mr-2"></i> +86 139 2377 6251</li>
            <li><i class="fa fa-envelope mr-2"></i> sales@hdsilicone.com</li>
            <li>
              <i class="fa fa-comment mr-2"></i> Whatsapp: +86 139 2377 6251
            </li>
          </ul>
        </div>

        <div class="border-r border-gray-700 pr-4">
          <h3 class="text-xl font-bold mb-4 text-white">HUADAI SILICONE</h3>
          <p class="text-sm text-gray-400">
            <i class="fa fa-building mr-2"></i>
            <span class="font-bold">Dongguan Huadai Silicone Co., Ltd.</span
            ><br />
            Room 101, Building 1, No.128 Huaxia Road, Qiaotou Town, Dongguan
            City, Guangdong Province, China
          </p>
        </div>

        <div>
          <h3 class="text-xl font-bold mb-4 text-white">
            TONGRUIKAI NEW MATERIALS
          </h3>
          <p class="text-sm text-gray-400">
            <i class="fa fa-building mr-2"></i>
            <span class="font-bold"
              >Dongguan TongRuiKai New Materials Co., Ltd.</span
            ><br />
            No.128 Huaxia Road, Qiaotou Town, Dongguan City, Guangdong Province,
            China
          </p>
        </div>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  name: 'Footer',
  components: {},
  data() {
    return {}
  },
  methods: {}
}
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/components/footer/FooterN.vue